<template>
  <div>
    <!--库位查看  -->
    <el-dialog title="库位查看" :visible.sync="dialogVisible" width="1550px" center>
      <!-- 列表 -->
      <div class="table" ref="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable" size="small">
          <el-table-column align="center" label="NO" width="45" prop="rowNumber" fixed="left">
          </el-table-column>
          <!-- 库位 -->
          <el-table-column align="center" :label="$t('message.location')" width="100px">
            <template slot-scope="scope">
              <!-- 与常规仓库一致，在完整库位编码前拼接区域用途编码。 -->
              <p>{{ scope.row.wms_grid.wms_shelf.area_type_code}}-{{ scope.row.grid_number.split("】-")[0] }}】-</p>
              <p style="color: #fa5058">
                {{ scope.row.grid_number.split("】-")[1] }}
              </p>
            </template>
          </el-table-column>
          <!-- 使用范围 -->
          <el-table-column align="center" :label="$t('message.scopeOfUse')" prop="wms_grid.wms_shelf.organization.name">
            <template slot-scope="scope">
              <div>
                <img :src="item.order_detail_label_config.icon" v-for="(item, index) in scope.row.order_detail_label"
                  :key="index" style="width: 30px; margin-right: 5px;">
              </div>
              <p>
                {{ scope.row.wms_grid.wms_shelf.organization.name }}
              </p>
            </template>
          </el-table-column>

          <!-- 入库时间 -->
          <el-table-column align="center" :label="$t('message.timeOfStorage')" prop="updated_at" width="82px">
            <template slot-scope="scope">
              <p>{{ scope.row.updated_at }}</p>
              <p v-if="scope.row.days_surplus_for_free !== ''">剩余保管</p>
              <p class="red" style="font-size: 12px;"> {{ scope.row.days_surplus_for_free === '' ? '订单未上完' :
                scope.row.days_surplus_for_free + '天' }} </p>
            </template>
          </el-table-column>
          <!-- 入金时间 -->
          <el-table-column align="center" :label="$t('message.timeOfPayment')"
            prop="order_purchase.order.order_time_node.datetime_pay_confirm" width="82px">
          </el-table-column>
          <!-- 上架完了时间 -->
          <el-table-column align="center" :label="$t('message.outOfShelfTime')"
            prop="order_purchase.order_detail.order_detail_time_node.datetime_store_complete" width="82px">
          </el-table-column>
          <!-- 订单编号 -->
          <el-table-column align="center" :label="$t('message.orderbianhao')" width="140px">
            <template slot-scope="scope">
              <p>
                <router-link :to="'/orderPaymentDetail?order_sn=' +
                  scope.row.order_purchase.order_sn
                  " target="_blank" style="color: #fa5058">{{ scope.row.order_purchase.order_sn }}</router-link>
              </p>
              <p>
                <router-link :to="'user/userWarehouse?userID=' + scope.row.order_purchase.order.user.id" target="_blank"
                  class="a-link">
                  {{ scope.row.order_purchase.order.user.realname }}</router-link>
              </p>
              <attributeName :name="scope.row.order_purchase.order.attribute_name" />
            </template>
          </el-table-column>
          <!-- 番号 -->
          <el-table-column align="center" :label="$t('message.mash')" width="50">
            <template slot-scope="scope">
              {{ scope.row.order_purchase.order_detail.sorting }}
              <!-- 查看配送单号 -->
              <el-popover placement="top-start" width="200" trigger="hover"
                v-if="scope.row.order_purchase.order_detail.porder_detail != false">
                <p v-for="(item, index) in scope.row.order_purchase.order_detail.porder_detail">{{ item.porder_sn }}</p>
                <img src="@/assets/icon/delivery.png" alt="" slot="reference" style="width: 30px;">
              </el-popover>
            </template>
          </el-table-column>
          <!-- 照片 -->
          <el-table-column align="center" :label="$t('message.pic')" prop="floor">
            <template slot-scope="scope">
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="scope.row.order_purchase.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                <a :href="`https://detail.1688.com/offer/${scope.row.order_purchase.order_detail.goods_id}.html`"
                  target="_blank" slot="reference">
                  <img :src="scope.row.order_purchase.order_detail.pic" alt="" style="width: 60px; height: 60px" />
                </a>
              </el-popover>
            </template>
          </el-table-column>
          <!-- 商品属性 -->
          <el-table-column align="center" :label="$t('message.commodityAttribute')">
            <template slot-scope="scope">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in scope.row.order_purchase
                      .order_detail.detail_y" :key="itemIndex" style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in scope.row.order_purchase
                      .order_detail.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <!-- 入金后数量 -->
          <el-table-column align="center" :label="$t('message.amountAfterGol')">
            <template slot-scope="scope">
              <div class="template">
                <div class="template">
                  <!-- 可入库 -->
                  <p>
                    {{ $t("message.canBePutIntoStorage") }}:{{
                      scope.row.order_purchase.possible_num
                    }}
                  </p>
                  <!-- 已到货 -->
                  <p>
                    {{ $t("message.itHasArrived") }}:{{
                      scope.row.order_purchase.storage_num
                    }}
                  </p>
                  <!-- 已出货 -->
                  <p>
                    {{ $t("message.shipped") }}:{{
                      scope.row.order_purchase.p_num
                    }}
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 已提出配送单数 -->
          <el-table-column align="center" :label="$t('message.numberOfDeliveryOrdersProposed')">
            <template slot-scope="scope">
              {{ scope.row.order_purchase.p_detail_created_num }}
            </template>
          </el-table-column>
          <!-- 库位数 -->
          <el-table-column align="center" :label="$t('message.numberOfLibraryPositions')" prop="num">
          </el-table-column>
          <!-- 可移库数 -->
          <el-table-column align="center" :label="$t('message.numberOfRemovableLibraries')" prop="can_move_num">
          </el-table-column>

        </el-table>

      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
    }
  },
  methods: {
    // 常规,辅料,备品
    stockListCharge(order_purchase_id) {
      let datas = {
        order_purchase_id,
        shelf_type: 1,
        page: 1,

      }
      this.$api.warehouseApi.stockList(datas).then((res) => {
        this.tableData = res.data.data;
        this.dialogVisible = true
      });
    },
  },
}
</script>
<style scoped>
.template {
  width: 100%;
  text-align: left;
}
</style>
